"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setSentryTags = exports.setSentryTag = exports.initSentry = void 0;
const browser_1 = require("@sentry/browser");
const integrations_1 = require("@sentry/integrations");
const react_1 = require("@sentry/react");
const initSentry = ({ dsn, auto = false, tracing = false, environment, version, replays = false, }) => {
    const integrations = [
        ...(replays
            ? [new react_1.Replay({ maskAllText: true, blockAllMedia: true })]
            : []),
        ...(tracing ? [new browser_1.BrowserTracing({
                startTransactionOnLocationChange: false,
                startTransactionOnPageLoad: false
            })] : []),
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ...(auto ? [new integrations_1.CaptureConsole({ levels: ['error'] })] : []),
    ];
    (0, react_1.init)(Object.assign(Object.assign({ dsn,
        integrations, tracesSampleRate: 0.2, release: version ? version : environment, 
        // If the entire session is not sampled, use the below sample rate to sample
        // sessions when an error occurs.
        replaysOnErrorSampleRate: 0.1, environment }, (!auto && { defaultIntegrations: false })), { denyUrls: [/extensions\//i, /metrix/i], ignoreErrors: [/(warning|deprecated)/i] }));
};
exports.initSentry = initSentry;
const setSentryTag = (key, value) => {
    (0, browser_1.setTags)({ [key]: value });
};
exports.setSentryTag = setSentryTag;
const setSentryTags = (tags) => {
    (0, browser_1.setTags)(tags);
};
exports.setSentryTags = setSentryTags;
